import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '@common/global';
import * as sha512 from 'js-sha512';
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.sass']
})
export class PaymentComponent implements OnInit {

  public payuform: any = {};
  disablePaymentButton: boolean = true;
  txnid="";
  key="";
  hash="";
  salt="";
  hashSequence="";
  constructor(private _global: GlobalService,private http: HttpClient) { 
    this.txnid=this._global.getRandomUuid();
    this.txnid=sha512.sha512(this.txnid).substring( 0, 20);
    this.key=this._global.PAYU_MERCHANT_KEY;
    this.salt=this._global.PAYU_MERCHANT_SALT;
    this.hash=sha512.sha512(this.key+"|"+this.txnid+"|5|test|test|test@gmail.com|||||||||||"+this.salt);
   //this.hashSequence = "key|txnid|amount|productinfo|firstname|email|udf1|udf2|udf3|udf4|udf5|udf6|udf7|udf8|udf9|udf10";
  }

  ngOnInit(): void {
  }

  confirmPayment() {

    //let hashSequence = "key|txnid|amount|productinfo|firstname|email|udf1|udf2|udf3|udf4|udf5|udf6|udf7|udf8|udf9|udf10";

  }

}
